// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"9aff23a5","487":"bc19ee3a","787":"bc7d429a"}[chunkId] + ".chunk.js";
};